import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ControlPointService } from '../../../shared/services/control-points/control-point.service';

/**
 * Read-only control-point check-in history (controlpoints.view). Shows the
 * most recent 200 check-ins reverse-chronological in a PrimeNG p-table:
 * control point name, trainer name, and Berlin-formatted date/time. The
 * trainer name is a flat helper projected after Zod validation in the service.
 */
@Component({
  selector: 'app-control-points-history-page',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, CardModule, TableModule],
  templateUrl: './history-page.component.html',
  styleUrl: './history-page.component.scss',
})
export class HistoryPageComponent implements OnInit {
  service = inject(ControlPointService);

  ngOnInit(): void {
    this.service.getCheckins();
  }
}
